import {
  Form,
  InputNumber,
  Popconfirm,
  Table,
  Typography,
  Input,
  Space,
  Button,
  notification,
  Select,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useState, useRef, useEffect } from "react";
import Highlighter from "react-highlight-words";
import { useAtom } from "jotai";
import { accessTokenAtom } from "../atoms";
import { Link } from "react-router-dom";

let tablelabel;

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  return <td {...restProps}>{children}</td>;
};

const TemplateTable = ({ defaultColumns, dummyData, label, token }) => {
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([...dummyData]);
  const [accessAtom, setAPIAtom] = useAtom(accessTokenAtom);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const [editingKey, setEditingKey] = useState("");
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    setDataSource([...dummyData]);
  }, [dummyData]);

  tablelabel = label;

  const openNotification = () => {
    api.error({
      message: `Delete Error`,
      description: "Delete Error Content",
      placement: "top",
    });
  };

  const handleCancel = () => {
    setEditingKey("");
  };

  const handleSave = async (record) => {
    try {
      const row = await form.validateFields();
      const newData = [...dataSource];
      const index = newData.findIndex((item) => record.serialNumber === item.serialNumber);
      const bearer = `Bearer ${token}`;
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setDataSource(newData);
        fetch(`${process.env.REACT_APP_API_URL}ActiveProject/UpdateActiveProject`, {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: bearer,
          },
          body: JSON.stringify(newData[index]),
        });
        setEditingKey("");
      } else {
        newData.push(row);
        setDataSource(newData);
        setEditingKey("");
      }
    } catch (errInfo) {}
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText((selectedKeys.length === 0 && "") || selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm, dataIndex) => {
    clearFilters();
    handleSearch([], confirm, dataIndex);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters, confirm, dataIndex)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text, record) => {
      return searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      );
    },
  });

  const columns = defaultColumns.map((col) => {
    // Add a search filter functionality
    const newCol = {
      ...col,
      ...getColumnSearchProps(col.dataIndex),
    };

    if (col.dataIndex !== "operation") {
      return newCol;
    }

    // Add edit and delete functionality under the column "operation"
    return {
      ...col,
      render: (_, record) => {
        return (
          <span>
            {label === "Email" ? (
              <Link
                to={{ pathname: `/editEmailTemplate`, search: `id=${record.id}` }}
                state={record}
                style={{ marginRight: "8px" }}
              >
                Edit
              </Link>
            ) : label === "Residential" ? (
              <Link
                to={{ pathname: `/editCertificateTemplate`, search: `${label}` }}
                state={{ record, label }}
                style={{ marginRight: "8px" }}
              >
                {/* search:`id=${record}` */}
                Edit
              </Link>
            ) : label === "C&I" ? (
              <Link
                to={{ pathname: `/editCertificateTemplate`, search: `${label}` }}
                state={{ record, label }}
                style={{ marginRight: "8px" }}
              >
                Edit
              </Link>
            ) : null}
            {/* <Popconfirm title="Do you want to remove this record?" onConfirm={() => handleDelete(record)} disabled={record.availableQuantity==record.totalQuantity?false:true}>
                            <Typography.Link>
                                Delete
                            </Typography.Link>
                        </Popconfirm> */}
            {/* {record.availableQuantity==record.totalQuantity?   <Popconfirm title="Do you want to remove this record?" onConfirm={() => handleDelete(record)} disabled={record.availableQuantity==record.totalQuantity?false:true}>
                            <Typography.Link>
                                Delete
                            </Typography.Link>
                        </Popconfirm>: <Typography.Link onClick={()=>openNotification()}>
                                Delete
                            </Typography.Link>} */}
          </span>
        );
      },
    };
  });

  // Make the cell of each row editable
  const mergedColumns = columns.map((col) => {
    return col;
  });

  const components = {
    body: {
      cell: EditableCell,
    },
  };

  return (
    <div style={{ overflowX: "auto" }}>
      {contextHolder}

      <Table
        components={components}
        bordered
        dataSource={[...dataSource]}
        columns={mergedColumns}
        rowKey={"id"}

        rowClassName="editable-row"
        pagination={{
          pageSize: 5,
          onChange: handleCancel,
        }}
      />
    </div>
  );
};

export default TemplateTable;
